import React, { useState, useEffect, useContext } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./VariationsDropdown.module.sass";
import Tooltip from "../Tooltip";
import { GlobalState } from "../../App";

const VariationsDropdown = ({
  className,
  classDropdownHead,
  classDropdownLabel,
  value,
  // setValue,
  options,
  label,
  tooltip,
  small,
  upBody,
  handlechangeVal,
  placeholder,
  onClick,
  isFrom,
  id,
  varId,
  ...props
}) => {
  const [visible, setVisible] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0)
  const { variationsList, notifyVariationList, setNotifyVariationList } = useContext(GlobalState)
  const handleClick = async (valueSelected, index) => {

    if (index === 0) {
      variationsList[selectedIndex].status = ""
    } else {
      variationsList.forEach((variation, i) => {
        if (variation.id === varId) {
          document.getElementById(`${id}$status`).innerHTML = valueSelected
          variationsList[i].status = valueSelected
          if (valueSelected === "Out Of Stock") {
            variationsList[i].quantity = 0
          }
          setNotifyVariationList(!notifyVariationList)
          setVisible(false);
        }
      });
    }
  };

  useEffect(() => {
    document.getElementById(`${id}$status`).innerHTML = value
  }, [])

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      {label && (
        <div className={cn(styles.label, classDropdownLabel)}>
          {label}{" "}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place="right"
            />
          )}
        </div>
      )}
      <div
        className={cn(
          styles.dropdown,
          className,
          { [styles.small]: small },
          {
            [styles.active]: visible,
          }
        )}
      >
        <div
          className={cn(styles.head, classDropdownHead)}
          onClick={() => {
            setVisible(!visible);
            setSelectedIndex(varId)
          }}
        >

          <div className={styles.selection} id={`${id}$status`}>{
            // variationsList[selectedIndex]?.status === '' ? "Select status" : variationsList[selectedIndex]?.status
            value === '' ? "Select status" : value

          }</div>


        </div>
        <div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
          {options.map((x, index) => {
            return (
              <div
                className={cn(styles.option, {
                  // [styles.selectioned]: x === value,
                })}
                onClick={() => {

                  index === 0 ?
                    <></> :

                    handleClick(x, index)
                }
                }
                key={index}
                placeholder={placeholder}
                {...props}
              >
                {x}
              </div>
            )
          })}
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default VariationsDropdown;
